export const getFilteredCrosswords = (crosswords, { status, text }) => {
    return crosswords
        .filter((crossword) => text && text != '' ? crossword.name.toLowerCase().includes(text) : true)
        .filter((crossword) => (status ? crossword.status === status : true));
};
